import React from "react";

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import AppHome from "./pages/AppHome";

import LandingPage from "./pages/Landing";
import AccountDeletedPage from "./pages/AccountDeleted";
import TermsPage from "./pages/Terms";
import PrivacyPolicyPage from "./pages/PrivacyPolicy";

import TokenAccept from "./components/TokenAccept";
import Layout from "./components/Layout";

export default () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <LandingPage />
        </Route>
        <Route path="/terms">
          <TermsPage />
        </Route>
        <Route path="/privacy">
          <PrivacyPolicyPage />
        </Route>
        <Route path="/a">
          <AppHome />
        </Route>
        <Route path="/token-accept">
          <TokenAccept />
        </Route>
        <Route path="/account-deleted">
          <Layout title="Reconcile" noBottomNav>
            <AccountDeletedPage />
          </Layout>
        </Route>
      </Switch>
    </Router>
  );
};
